import { render } from "./FileUploadV2.vue?vue&type=template&id=7e58e45c&scoped=true&ts=true"
import script from "./FileUploadV2.vue?vue&type=script&lang=ts"
export * from "./FileUploadV2.vue?vue&type=script&lang=ts"

import "./FileUploadV2.vue?vue&type=style&index=0&id=7e58e45c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e58e45c"]])

export default __exports__